export default __webpack_public_path__ + "media/images/user_photos/132-7ff3fe34e7ee9fb2ba440e9f3d1b2364.jpg";